import React, { useMemo } from 'react';
import { BeveledPanel } from '../FabProcessTool/BeveledPanel';
import {
  getGraphiteMetal,
  getWhitePaintedMetal,
} from '../FabProcessTool/equipmentMaterials';
import type { Awp300Layout } from './awp300Layout';

export type Awp300ControlPanelProps = {
  layout: Awp300Layout;
  id?: string;
  opacity?: number;
};

/** Front-right pillar HMI — cyan touch screen + red e-stop. */
export const Awp300ControlPanel: React.FC<Awp300ControlPanelProps> = ({
  layout,
  id = 'AWP-300',
  opacity = 1,
}) => {
  const white = useMemo(() => getWhitePaintedMetal(opacity), [opacity]);
  const graphite = useMemo(() => getGraphiteMetal(opacity), [opacity]);
  const { depth, frameT, panelX, panelY, panelZ, pillarTop, pillarBottom } = layout;
  const panelH = (pillarTop - pillarBottom) * 0.26;

  return (
    <group name={`Awp300ControlPanel-${id}`} position={[panelX, panelY, panelZ]}>
      <BeveledPanel
        size={[frameT * 4, panelH, depth * 0.045]}
        material={white}
        castShadow
      />
      <BeveledPanel
        size={[frameT * 3, panelH * 0.45, depth * 0.012]}
        material={graphite}
        position={[0, panelH * 0.1, depth * 0.024]}
      />
      <mesh position={[0, panelH * 0.12, depth * 0.03]}>
        <boxGeometry args={[frameT * 2.4, panelH * 0.3, depth * 0.006]} />
        <meshStandardMaterial
          color="#081820"
          emissive="#38E4FF"
          emissiveIntensity={1.05}
          toneMapped={false}
          transparent={opacity < 1}
          opacity={opacity}
        />
      </mesh>
      <mesh position={[0, -panelH * 0.28, depth * 0.028]}>
        <cylinderGeometry args={[frameT * 1, frameT * 1, depth * 0.014, 20]} />
        <meshStandardMaterial color="#D4B820" metalness={0.4} roughness={0.38} />
      </mesh>
      <mesh position={[0, -panelH * 0.26, depth * 0.036]}>
        <cylinderGeometry args={[frameT * 0.72, frameT * 0.72, depth * 0.01, 20]} />
        <meshStandardMaterial
          color="#D62828"
          emissive="#991818"
          emissiveIntensity={0.75}
          toneMapped={false}
        />
      </mesh>
    </group>
  );
};

export default Awp300ControlPanel;
